import React from "react";
import { useTranslation } from "react-i18next";
import "./InfoPanel.scss";
import Verca from "../../assets/verca-new.jpg";

const InfoPanel = () => {
  const { t } = useTranslation();
  return (
    <div className="info-panel">
      <div className="left">
        <img src={Verca} className="author" alt="Veronika :)" />
      </div>

      <div className="right">
        <h3>{t("About.Heading")}</h3>
        <p>{t("About.Text")}</p>

        <h4>{t("About.EducationHeading")}</h4>
        <p>
          <span style={{ fontWeight: "400", paddingRight: 10 }}>
            2011 – 2015:
          </span>
          {t("About.Education1")}
        </p>
        <p>
          <span style={{ fontWeight: "400", paddingRight: 10 }}>
            2007 - 2011:
          </span>
          {t("About.Education2")}
        </p>
      </div>
    </div>
  );
};

export default InfoPanel;
